<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';

const emit = defineEmits(['submit']);

const { t } = useI18n();
const getters = useStoreGetters();

const dialogRef = ref(null);
const selectedReasonId = ref(null);
const conversationContext = ref(null);

const closureReasons = computed(
  () => getters['closureReasons/getClosureReasons'].value
);

const reasonOptions = computed(() =>
  closureReasons.value.map(reason => ({
    value: reason.id,
    label: reason.name,
  }))
);

const close = () => {
  dialogRef.value?.close();
  conversationContext.value = null;
};

const open = (context = null) => {
  selectedReasonId.value = null;
  conversationContext.value = context;
  dialogRef.value?.open();
};

const handleConfirm = () => {
  if (!selectedReasonId.value) return;

  emit('submit', {
    closureReasonId: selectedReasonId.value,
    context: conversationContext.value,
  });
  close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="md"
    overflow-y-auto
    :title="t('CLOSURE_REASONS.DIALOG.TITLE')"
    :description="t('CLOSURE_REASONS.DIALOG.DESCRIPTION')"
    :confirm-button-label="t('CLOSURE_REASONS.DIALOG.CONFIRM')"
    :cancel-button-label="t('CLOSURE_REASONS.DIALOG.CANCEL')"
    :disable-confirm-button="!selectedReasonId"
    @confirm="handleConfirm"
  >
    <ComboBox
      v-model="selectedReasonId"
      :options="reasonOptions"
      :placeholder="t('CLOSURE_REASONS.DIALOG.PLACEHOLDER')"
      class="w-full"
    />
  </Dialog>
</template>
